<div
  (click)="copyToClipboard()"
  (keydown)="onKeyPress($event)"
  pTooltip="Click to copy"
  tooltipPosition="left"
  tooltipStyleClass="leftTooltip p-tooltip-text"
  class="ms-auto me-2 fs-10 id-container"
  [style.margin-bottom]="margin ? '5px' : '0px'"
>
  <span class="id-text">ID : {{ id }}</span>
  <span class="copy-text">
    <img src="assets/Inbox/copy_icon_outline1.svg" alt="Copy icon" width="14" height="16" />
  </span>
</div>